import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BadgeCheck } from "lucide-react";
import { api } from "@/lib/api";
import { MF_KEYS } from "@/lib/marketingFoundations";

export const FoundationsBadge = () => {
  const [done, setDone] = useState(null);
  useEffect(() => { api.get("/me/foundations-checklist").then((r) => setDone(r.data.done)).catch(() => {}); }, []);
  if (!done || !Object.entries(MF_KEYS).some(([v, keys]) => keys.every((k) => done.includes(`${v}:${k}`)))) return null;
  return (
    <Link to="/app/guides?tab=basics" data-testid="dashboard-foundations-badge" title="All the marketing basics are in place"
      className="inline-flex items-center gap-1.5 rounded-full bg-leaf/15 border border-leaf/40 px-3 py-1 text-xs font-medium text-navy transition-colors hover:bg-leaf/25">
      <BadgeCheck className="h-3.5 w-3.5 text-leaf" />Basics in place
    </Link>
  );
};
